import React, { useEffect, useMemo } from 'react';
import { MapContainer, TileLayer, Marker, Popup, AttributionControl, useMap } from 'react-leaflet';
import L from 'leaflet';
import '../address/mapIconFix';
import { hasSchoolCoordinates, pickSchoolLat, pickSchoolLng } from '../../utils/schoolCoordinates';

const TILE_URL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
const ATTRIBUTION =
    '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap</a> contributors';
const MOSCOW = [55.7558, 37.6173];

function FitSchoolBounds({ schools }) {
    const map = useMap();
    const points = useMemo(
        () => schools
            .filter((s) => hasSchoolCoordinates(s))
            .map((s) => [pickSchoolLat(s), pickSchoolLng(s)]),
        [schools]
    );

    useEffect(() => {
        if (points.length === 0) {
            map.setView(MOSCOW, 10, { animate: false });
            return;
        }
        if (points.length === 1) {
            map.setView(points[0], 14, { animate: true });
            return;
        }
        map.fitBounds(L.latLngBounds(points), { padding: [48, 48], maxZoom: 13, animate: true });
    }, [map, points]);

    return null;
}

function FocusSelected({ school }) {
    const map = useMap();
    useEffect(() => {
        if (school?.lat == null || school?.lng == null) return;
        map.setView([Number(school.lat), Number(school.lng)], Math.max(map.getZoom(), 15), { animate: true });
    }, [school?.id, school?.lat, school?.lng, map]);
    return null;
}

export default function SchoolsMap({
    schools = [],
    selectedSchool = null,
    onSelectSchool,
    height = '420px'
}) {
    const onMap = useMemo(
        () => schools.filter((s) => hasSchoolCoordinates(s)),
        [schools]
    );

    if (onMap.length === 0) {
        return (
            <div style={{
                height,
                borderRadius: 12,
                border: '1px dashed #cbd5e1',
                background: '#f8fafc',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#64748b',
                fontSize: 14,
                textAlign: 'center',
                padding: 24
            }}>
                ��� ���� � ������������ �� �����. � ���������� ����� ������� ����� � ������� �����������, ���� ������� ������ ���� ������.
            </div>
        );
    }

    const center = selectedSchool && hasSchoolCoordinates(selectedSchool)
        ? [pickSchoolLat(selectedSchool), pickSchoolLng(selectedSchool)]
        : [pickSchoolLat(onMap[0]), pickSchoolLng(onMap[0])];

    return (
        <div style={{
            height,
            borderRadius: 12,
            overflow: 'hidden',
            border: '1px solid var(--sp-gray-200)',
            position: 'relative',
            zIndex: 0
        }}>
            <MapContainer
                center={center}
                zoom={11}
                style={{ height: '100%', width: '100%' }}
                scrollWheelZoom
                attributionControl={false}
            >
                <TileLayer url={TILE_URL} attribution={ATTRIBUTION} maxZoom={19} />
                <AttributionControl prefix={false} />
                <FitSchoolBounds schools={onMap} />
                <FocusSelected school={selectedSchool} />
                {onMap.map((s) => {
                    const isSelected = selectedSchool?.id === s.id;
                    const lat = pickSchoolLat(s);
                    const lng = pickSchoolLng(s);
                    return (
                        <Marker
                            key={s.id}
                            position={[lat, lng]}
                            eventHandlers={{
                                click: () => onSelectSchool?.(s)
                            }}
                            opacity={isSelected ? 1 : 0.85}
                        >
                            <Popup>
                                <div style={{ minWidth: 160, fontFamily: 'Segoe UI, Arial, sans-serif' }}>
                                    <div style={{ fontWeight: 700, marginBottom: 4 }}>
                                        {s.sportIcon ? `${s.sportIcon} ` : ''}{s.name}
                                    </div>
                                    <div style={{ fontSize: 12, color: '#64748b', marginBottom: 8 }}>
                                        {s.sportType || '�'}
                                        {s.city ? ` � ${s.city}` : ''}
                                    </div>
                                    {(s.addressFull || s.address) && (
                                        <div style={{ fontSize: 11, color: '#94a3b8', marginBottom: 8 }}>
                                            {s.addressFull || s.address}
                                        </div>
                                    )}
                                    <button
                                        type="button"
                                        onClick={() => onSelectSchool?.(s)}
                                        style={{
                                            padding: '6px 10px',
                                            borderRadius: 8,
                                            border: 'none',
                                            background: '#EB3333',
                                            color: '#fff',
                                            fontWeight: 600,
                                            fontSize: 12,
                                            cursor: 'pointer',
                                            width: '100%'
                                        }}
                                    >
                                        �������
                                    </button>
                                </div>
                            </Popup>
                        </Marker>
                    );
                })}
            </MapContainer>
        </div>
    );
}
